export default __webpack_public_path__ + "659f503e243d9b1fa2dc01654f659a16.jpg";